/**
 * Superficie apta para un bundle cliente: todo menos las páginas de ruta de
 * Next (`DocumentRenderPage` importa `next/headers`). La usa backoffice-app
 * para previsualizar un template con el mismo componente que imprime el PDF.
 */
export * from './registry'

export * from './components/Brandmark'
export * from './components/DocumentFooter'
export * from './components/DocumentHeader'
export * from './components/DocumentPage'
export * from './components/DocumentPreviewFrame'
export * from './components/KeyValueList'
export * from './components/PageBreak'
export * from './components/Section'
export * from './components/SignatureSlot'
export * from './components/StaticTable'
export * from './components/Watermark'
export * from './next/DocumentStyleReset'
